import { Breakpoints } from '@angular/cdk/layout';

export const HANDHELD_DEVICE_BREAKPOINTS: string[] = [
  Breakpoints.XSmall,
  Breakpoints.Small,
  Breakpoints.HandsetPortrait,
  Breakpoints.HandsetLandscape,
  Breakpoints.TabletPortrait
]
